import React, { useState } from "react";
import { useGetStaff } from "hooks/warranty";
import { FilterLoadMore } from "../Filter";

export function FilterCreatedByIDs({ onFilter }) {
  const [params, setParams] = useState({
    filters: { query: undefined },
    pagination: { offset: 0, limit: 10 },
  });

  const { data, onLoadMoreData, hasMoreData, loading } = useGetStaff(params, "cache-first");

  const handleSearch = (value) => {
    setParams({
      filters: { ...params?.filters, query: value || undefined },
      pagination: { offset: 0, limit: 10 },
    });
  };

  return (
    <FilterLoadMore
      params={params}
      data={data || []}
      onLoadMoreData={onLoadMoreData}
      onFilter={(value) => onFilter(value?.length ? value : undefined)}
      onSearch={handleSearch}
      hasMore={hasMoreData}
      loading={loading}
    />
  );
}
